export const focusActionTokenPromptNowAndAfterRender = (focusPrompt: () => void) => {
    focusPrompt()
    window.requestAnimationFrame(focusPrompt)
}
